'use strict';

const FlightDetailsModel = Backbone.Model.extend({
    dataUrl: 'getflightdetails',
    isLoaded: false,
    url: function() {
        return Odigeo.Settings.getProperty('serviceUrlFormatter')(this.dataUrl);
    },
    initialize: function() {
        this.populateFlightDetails();
    },
    populateFlightDetails: function() {
        this.isLoaded = false;
        this.fetch(this.getDataRequestSettings());
    },
    getDataRequestSettings: function() {
        return {
            type: 'GET',
            processData: true,
            contentType: 'application/json',
            success: Odigeo._.bind(this.requestSuccessHandler, this),
        };
    },
    requestSuccessHandler: function() {
        this.isLoaded = true;
        this.trigger('flightDetailsIsOk');
    },
});

let instance;
module.exports.getInstance = function() {
    if (Odigeo._.isUndefined(instance)) {
        instance = new FlightDetailsModel();
    }
    return instance;
};
